import { Injectable } from '@angular/core';
import { catchError, Observable, of, throwError } from 'rxjs';
import { AssetCollectionClient, FilterDTO, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { ToastService } from 'src/app/base/services/toast.service';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { IPagedItems } from 'src/app/base/shared/syncfusion/paged-items.interface';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})
export class AssetCollectionsEditService extends ShowInactiveService implements IAdaptorService {
  
  public generateToken(): string {
    // generate a token of 24 characters containing numbers and letters both upper and lower case
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < 36; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
    
  }

  public set assetCollectionId(id: number){
    this._assetCollectionId = id;
    this.assetsToUnlink = [];
  }

  public get assetCollectionId(): number {
    return this._assetCollectionId;
  }

  public assetsToUnlink: number[] = [];

  private _assetCollectionId: number;

  constructor(
    private assetCollectionClient: AssetCollectionClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService
  ) {
    super();
  }

  getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    if (!this.assetCollectionId) {
      return of({ count: 0, items: [] });
    }
    return this.assetCollectionClient.searchAssetStorageEntriesForAssetCollection(this.assetCollectionId ,skip, take, sortBy, sortDirection, filters)
    .pipe(
      catchError((error: any) => {
        if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
          this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
        }
        return throwError(() => error);
      })
    );
  }

  addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  deleteRecord(id: number): Observable<any> {
    this.assetsToUnlink.push(id);
    return of(true);
  }
 
}
